const en = {
  i18nView: {
    login: 'Login',
    logout: 'Logout',
    basePrice: 'Starting price',
    auctionConfirm: 'Confirm Bid',
    search: 'Search',
    currentPrice: 'Current',
    bidder: 'Bidder',
    finished: 'Finished',
    hour: 'h',
    minute: 'm',
    second: 's',
    claim: 'Claim',
    bidFinished: 'Finished',
    bidded: 'Already Bid',
    joinBid: 'Bid Name',
    please: 'Please',
    loginFirst: 'Please login first',
    newAuction: 'New bid',
    pubkeyToReceive: 'The public key to receive the account',
    searchPlaceholder: 'Search the account (4-7)',
    dealPrice: 'Deal price',
    bidOwner: 'Winner',
    dealTime: 'Deal time',
    auction: 'Auction',
    mine: 'Me',
    deal: 'Deal',
    rules: 'Rules',
    accountLength: 'Account Length',
    accountLengthDesc: 'Account with length of 7-10, include \'.tp\' ',
    newAccount: 'Bid a new Account',
    newAccountDesc: 'Search your account, if it is not taken, you can start a bid',
    process: 'Bidding process',
    processDesc: 'Minimum increase of 500 TPT per bid',
    dealRules: 'Deal rules',
    dealDesc: 'Only the top 50 auctions will be dealt successfully after the countdown. Each new bid will reset the countdown to 12 hours',
    PublicKeyFirst: 'Please fill your publick key',
    bidSuccess: 'Succeed!',
    claimSuccess: 'Succeed!',
    lengthTips: 'Account with a length of 4-7 is allowed'
  }
};

export default en;
